<template>
  <div class="outer-wrapper">
    <div class="editor-wrapper" v-show="!detailShow">
      <div class="title-wrapper">
        <span>失效案例</span>
      </div>
      <van-search placeholder="请输入搜索关键词" v-model="keyword" @search="onSearch" />
      <van-list
        v-model="itemTable.loading"
        :finished="itemTable.finished"
        finished-text="没有更多了"
        :error.sync="itemTable.error"
        error-text="请求失败，点击重新加载"
        @load="onLoad"
      >
        <van-cell
          v-for="item in itemTable.tivdata"
          :key="item.id+'verify'"
          :title="item.title"
          :label="item.material"
          label-class="cell-label"
          @click="chooseItem(item)"
          is-link
          :value="item.fa_type"
        ></van-cell>
      </van-list>
    </div>
    <div class="report-wrapper" v-show="detailShow">
      <van-nav-bar title="案例详情" left-text="返回" left-arrow @click-left="onClickBack" fixed></van-nav-bar>
      <p
        class="detail-title"
      >{{currentItem.title}}</p>
      <van-panel title="工艺：" desc status>
        <div class="d-wrapper">
          <p>{{currentItem.craft}}</p>
        </div>
      </van-panel>
      <van-cell title="失效时段" :value="currentItem.fa_period" />
      <van-cell title="材料" :value="currentItem.material" />
      <van-cell title="失效类型" :value="currentItem.fa_type" />
      <van-panel title="原因：" desc status>
        <div class="d-wrapper">
          <p>{{currentItem.reason}}</p>
        </div>
      </van-panel>
      <van-cell title="撰写者" :value="currentItem.author" />
      <van-cell title="详情" value="点击下载标准" is-link @click="linkTo(currentItem.file_url)" />
    </div>
  </div>
</template>
<script>
let userToken = localStorage.getItem("current_user_token");
let authData = JSON.parse(localStorage.getItem("authData"));

function itemTableFac() {
  return {
    loading: false,
    finished: false,
    error: false,
    Tpage: {
      currentPage: 1,
      currentSize: 20
    },
    no_data_text: "",
    totalItems: 0,
    tivdata: [
    ]
  };
}


export default {
  name: "raList",
  props: [],
  components: {
  },
  data() {
    return {
      itemTable: itemTableFac(),
      detailShow: false,
      currentItem: {},
      keyword: "",
      askData: "faList",
    };
  },
  methods: {
    linkTo(url) {
      window.open(this.$fileUrlFac(url, authData.sfileRight));
    },
    onSearch() {
      this.itemTable = itemTableFac();
      this.onLoad();
    },
    onLoad() {
      this.itemTable.loading = true;
      this.$axios
        .post(this.$url + "/ask_list_data", {
          page: this.itemTable.Tpage,
          userToken: userToken,
          ask_data: "faList",
          selected_list: [],
          keyword: this.keyword
        })
        .then(response => {
          for (let ele of response.data.res_record) {
            this.itemTable.tivdata.push(ele);
          }
          if (
            response.data.res_record.length < this.itemTable.Tpage.currentSize
          ) {
            this.itemTable.finished = true;
          }
          this.itemTable.loading = false;
          this.itemTable.Tpage.currentPage++;
        });
    },
    chooseItem(val) {
      this.currentItem = val;
      this.detailShow = true;
    },
    onClickBack() {
      this.detailShow = false;
    }
  }
};
</script>
<style scoped>
.inner-wrapper {
  width: 100%;
  background: #f7f7f7;
  min-height: 20rem;
}

.title-wrapper {
  text-align: center;
  font-size: 0.8rem;
  color: #999;
  padding: 1rem;
  background: #fff;
  border-bottom: 1px solid #f6f6f6;
}

.editor-wrapper {
  width: 100%;
}
.cell-item {
  margin-left: 0.6rem;
}
.d-wrapper {
  padding: 0.5rem 1rem;
  text-align: left;
  text-indent: 1rem;
  font-size: 0.6rem;
}

.cell-label {
  width: 180%;
  color: #666;
}
.detail-title {
  text-align: center;
  font-size: 0.8rem;
  padding: 0.5rem 0;
}

</style>